import { useState } from 'react';
import { Menu } from '@mantine/core';
import { useMedplum } from '@medplum/react';
import { IconLogout, IconUser, IconChevronDown } from '@tabler/icons-react';
import { useProfile } from '../hooks/useProfile';
import { ProfileModal } from './ProfileModal';

interface AppHeaderProps {
  showStatus?: boolean;
  statusText?: string;
  showUserMenu?: boolean;
}

export function AppHeader({ showStatus = false, statusText = "System Access // v2.0.4", showUserMenu = false }: AppHeaderProps) {
  const medplum = useMedplum();
  const { profileData } = useProfile();
  const [profileModalOpen, setProfileModalOpen] = useState(false);

  const handleLogout = async () => {
    await medplum.signOut();
    window.location.href = '/signin';
  };

  const displayName = profileData.firstName || profileData.email || 'User';

  return (
    <header className="mb-10">
      {showUserMenu && (
        <div className="flex justify-end mb-4">
          <Menu
            shadow="md"
            width={200}
            position="bottom-end"
            styles={{
              dropdown: {
                backgroundColor: 'rgba(10, 15, 30, 0.95)',
                border: '1px solid rgba(0, 240, 255, 0.15)',
                backdropFilter: 'blur(12px)',
              },
              item: {
                color: 'var(--color-text-primary)',
                '&[data-hovered]': {
                  backgroundColor: 'var(--color-bg-tertiary)',
                },
              },
            }}
          >
            <Menu.Target>
              <button className="flex items-center gap-2 px-3 py-2 text-sm text-gray-300 hover:text-gray-100 hover:bg-gray-800/50 rounded-md transition-colors">
                <IconUser size={18} />
                <span>{displayName}</span>
                <IconChevronDown size={14} />
              </button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item
                leftSection={<IconUser size={16} />}
                onClick={() => setProfileModalOpen(true)}
              >
                Edit Profile
              </Menu.Item>
              <Menu.Divider />
              <Menu.Item
                leftSection={<IconLogout size={16} />}
                onClick={handleLogout}
                color="red"
              >
                Sign out
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      )}
      <ProfileModal
        opened={profileModalOpen}
        onClose={() => setProfileModalOpen(false)}
      />
      <div className="text-center">
        {showStatus && (
          <div className="flex items-center justify-center gap-2 mb-2 opacity-70">
            <div className="w-2 h-2 bg-cyan-400 rounded-full animate-ping" />
            <span className="text-xs text-cyan-400 font-mono tracking-[0.2em] uppercase">
              {statusText}
            </span>
          </div>
        )}
        <h1 className="text-4xl font-bold tracking-tight mb-2 text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
          Precision Longevity
        </h1>
        <p className="text-gray-400 font-mono tracking-wider text-sm uppercase">
          Architectural Blueprint Instrument
        </p>
      </div>
    </header>
  );
}
